import { sum } from "lodash";

export function getPredictionInterval({ actual, predicted }) {
  // some zValue options to make the prediction band smaller or larger.
  // the keys represent the percent likelihood that a new prediction will
  // fall within the interval given.
  const zValuesByPercent = {
    68: 1.0,
    80: 1.28,
    90: 1.645,
    95: 1.96,
    98: 2.33
  };
  const zValue = zValuesByPercent[80]; // change this number until damien is happy :D
  const squaredErrors = actual.map((_, i) =>
    Math.pow(predicted[i][1] - actual[i][1], 2)
  );
  const standardDeviation = Math.sqrt(
    (1 / (actual.length - 2)) * sum(squaredErrors)
  );
  return zValue * standardDeviation;
}

export function getLocalStorageItem(key, fallback) {
  const item = window.localStorage.getItem(key);
  if (!item) return fallback;
  return JSON.parse(item);
}

export function setLocalStorageItem(key, value) {
  return window.localStorage.setItem(key, JSON.stringify(value));
}
